import React from 'react';

const CompanyLink = ({ href, icon, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className="inline-flex items-center gap-1.5 text-accent"
  >
    <img
      src={icon}
      alt=""
      aria-hidden="true"
      className="h-4 w-4 shrink-0 rounded-sm object-contain"
    />
    {children}
  </a>
);

export default CompanyLink;
